"use client";

import { c as _c } from "react/compiler-runtime";
import { useFilter } from "@repo/design-system/hooks/use-filter";
import type { Filter, FilterValue } from "@repo/design-system/types/filter";
import type { Option } from "@repo/design-system/types/filtermenu";
import { cn } from "@repo/design-system/utils/cn";
import { useState } from "react";
import { Combobox, ComboboxContent, ComboboxControls, ComboboxFloatingLabel, ComboboxInput, ComboboxInputGroup, ComboboxItem, ComboboxList } from "~/components/ui/combobox-eon";
import { useLanguage } from "~/translations/loader/use-language";
import { OptionDisplay } from "./select-layout-eon";
export interface MultiSelectProps {
  className?: string;
  filterBy: Filter[];
  id: string;
  label: string;
}
export function MultiSelect(t0) {
  const $ = _c(38);
  const {
    id,
    label,
    filterBy,
    className
  } = t0;
  const t = useLanguage();
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] !== filterBy) {
    t1 = {
      filterTypes: filterBy,
      sorting: "alphabetically"
    };
    $[0] = filterBy;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    clearFilter,
    toggleFilter,
    activeFilters,
    options
  } = useFilter(t1);
  const hasValue = activeFilters.length > 0;
  const floating = open;
  let t2;
  if ($[2] !== activeFilters || $[3] !== toggleFilter) {
    t2 = async newSelection => {
      const currentSet = new Set(activeFilters.map(_temp));
      const newSet = new Set(newSelection.map(_temp2));
      const added = newSelection.find(f_1 => !currentSet.has(f_1.value));
      const removed = activeFilters.find(f_2 => !newSet.has(f_2.value));
      const changed = added ?? removed;
      if (changed) {
        await toggleFilter(changed.value as FilterValue);
      }
    };
    $[2] = activeFilters;
    $[3] = toggleFilter;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleValueChange = t2;
  let t3;
  if ($[5] !== className) {
    t3 = cn("relative", className);
    $[5] = className;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== floating || $[8] !== id || $[9] !== label) {
    t4 = <ComboboxFloatingLabel floating={floating} htmlFor={id}>{label}</ComboboxFloatingLabel>;
    $[7] = floating;
    $[8] = id;
    $[9] = label;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = options as Option[];
  const t6 = floating ? t.filterbar_filter1_placeholder_search : "";
  let t7;
  if ($[11] !== id || $[12] !== t6) {
    t7 = <ComboboxInput id={id} placeholder={t6} />;
    $[11] = id;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== activeFilters || $[15] !== hasValue) {
    t8 = hasValue && <OptionDisplay activeFilters={activeFilters} />;
    $[14] = activeFilters;
    $[15] = hasValue;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== clearFilter || $[18] !== hasValue || $[19] !== label || $[20] !== open) {
    t9 = <ComboboxControls hasValue={hasValue} label={label} onClear={clearFilter} open={open} />;
    $[17] = clearFilter;
    $[18] = hasValue;
    $[19] = label;
    $[20] = open;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== open || $[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
    t10 = <ComboboxInputGroup open={open}>{t7}{t8}{t9}</ComboboxInputGroup>;
    $[22] = open;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ComboboxContent><ComboboxList>{_temp5}</ComboboxList></ComboboxContent>;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== activeFilters || $[29] !== handleValueChange || $[30] !== open || $[31] !== t10 || $[32] !== t5) {
    t12 = <Combobox isItemEqualToValue={_temp3} items={t5} itemToStringLabel={_temp4} multiple={true} onOpenChange={setOpen} onValueChange={handleValueChange} open={open} value={activeFilters}>{t10}{t11}</Combobox>;
    $[28] = activeFilters;
    $[29] = handleValueChange;
    $[30] = open;
    $[31] = t10;
    $[32] = t5;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t12 || $[35] !== t3 || $[36] !== t4) {
    t13 = <div className={t3}>{t4}{t12}</div>;
    $[34] = t12;
    $[35] = t3;
    $[36] = t4;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  return t13;
}
function _temp5(item) {
  return <ComboboxItem key={item.value} value={item}><span>{item.label}</span><span>{item.count}</span></ComboboxItem>;
}
function _temp4(opt) {
  return opt.label;
}
function _temp3(a, b) {
  return a.value === b.value;
}
function _temp2(f_0) {
  return f_0.value;
}
function _temp(f) {
  return f.value;
}